import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const LAST_UPDATED = 'June 12, 2026';
const CONTACT_EMAIL = 'legal@signvoice.example';

/**
 * Privacy page — neutral theme, works inside both the Obsidian-Glass consumer
 * surface and the Elite-Dark Talent Connect surface. Placeholder copy pending
 * the orchestrator's final markdown.
 */
export default function Privacy() {
  return (
    <div className="legal-page" data-testid="privacy-page">
      <div className="legal-page-inner">
        <Link to="/" className="legal-back" data-testid="legal-back-link">
          <ArrowLeft className="w-4 h-4" />
          <span>Back</span>
        </Link>
        <p className="legal-eyebrow">SignVoice · Legal</p>
        <h1 className="legal-h1">Privacy Policy</h1>
        <p className="legal-meta">Last updated: {LAST_UPDATED}</p>

        <div className="legal-body">
          <p className="legal-placeholder">
            Legal content pending review. The full policy will appear here once approved by
            counsel. Until then, here is a short summary of how SignVoice currently treats your
            data:
          </p>

          <h2>1. What we collect</h2>
          <p>
            Video frames are processed entirely on your device by MediaPipe Hands. Frames never
            leave your browser. We persist only the spoken phrase ("Hello", "Thank you", etc.)
            you confirm by signing, tied to an anonymous session ID generated locally.
          </p>

          <h2>2. What we don't collect</h2>
          <p>
            No raw video, no audio, no biometric template, no facial features, no IP-based
            tracking beyond the request rate limiting required to keep the service up.
          </p>

          <h2>3. Talent Connect rooms</h2>
          <p>
            Recruiter–candidate sessions store yes/no/unsure answers in our database for as
            long as the room is active. Rooms expire automatically. No video is ever uploaded.
          </p>

          <h2>4. Contact</h2>
          <p>
            For privacy requests, deletions, or questions, write to{' '}
            <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
          </p>
        </div>
      </div>
    </div>
  );
}
